import '@sophocles/components/SystemNotice/SystemNoticeBanner.scss';

import { yellow } from '@mui/material/colors';
import DOMPurify from 'dompurify';
import React from 'react';

/** This is the actual banner that gets displayed to users, modify carefully.
 *  If html is passed, dangerously display that, otherwise use children.
 * * */

const SystemNoticeBanner = ({ close, html, children }) => (
  <div
    className="system-notice-banner"
    style={{
      width: '100%',
      backgroundColor: yellow[700],
      padding: '10px',
      position: 'relative',
    }}
  >
    <div style={{ marginRight: '20px' }}>
      {html ? <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} /> : children}
    </div>
    <i
      title="Close notice"
      style={{
        position: 'absolute',
        top: 0,
        right: 0,
        padding: '12px',
        cursor: 'pointer',
      }}
      className="far fa-times-circle"
      onClick={close}
    />
  </div>
);

export default SystemNoticeBanner;
